import React from "react";
import { Link } from "react-router-dom";
import s from '../componentsStlyes/Card.module.css'

export default function Card({title, image, diets, healthScore, id}){
    return (
        <div className={s.prueba}>
            <div className={s.divs}>
                <img className={s.imagen} src={image} alt='img not found' width='200px' height='250px'/>
            </div>
            <div  className={s.divs}>
                <h3 className={s.titulo}>{title}</h3>
            </div>
            <div  className={s.divs}>
                <h4 className={s.healthScore}>Health Score: {healthScore}</h4>
            </div>
            <div  className={s.divs}>
                <h5 className={s.dieta}>Diets: {diets + ''} </h5>
            </div>    
            <Link to= {`/recipes/${id}`}> 
                    <button className={s.boton}>Details </button>
            </Link>
        </div>
    )
}